const paths = {
    // Api addresses
    api: {
        admin: {
            AUTHENTICATE: '/admin/authenticate',
            REGISTER: '/admin/register',
            BIRD_EDIT_TEXT: '/admin/art/edit/text',
            BIRD_EDIT_FACTS: '/admin/art/edit/facts',
        },
        open: {
            BIRD_LIST_ALPHABETICALLY: '/home/alphabetically',
            BIRD_LIST_SYSTEMATICALLY: '/home/systematically',
            MOST_VIEWED_BIRDS: '/home/most-viewed-birds',
            RANDOM_HEADER_PHOTO: '/home/header-photo-random',
            GET_HEADER_PHOTO_FOR_HOME_GALLERY: '/home/header-photo-from-artnr',

            GET_THUMBNAIL_FOR_HOME_GALLERY: '/home/thumbnail-from-artnr',

            BIRD: '/art',
            GET_TEXT: "/art/get-text",
            GET_IMAGE: '/art/image',           
            GET_HEADER_PHOTO: '/art/header-photo-from-filename',
            GALLERY_ENTRIES: '/art/gallery-entries',       
            GET_SOUND: '/art/sound',
            GET_PHENOLOGY: '/art/phenology',     
            GET_PHENOLOGY_SPONTAN: '/art/phenology-spontan',     
            GET_PHENOLOGY_COMPLETE: '/art/phenology-complete',     
            GET_OBSERVATIONS: '/art/observations',  
            GET_OBSERVATION_DETAILS: '/art/observation-details',  

            GET_GIS: '/art/birdlife-geo',       

            GET_ATLAS_IMAGE: '/art/atlas-image',
            GET_LINKS_WITH_IMAGES: '/art/links-with-images',

            GET_IMAGE_IMG: '/bird/image-img',
        }
    }
}

export { paths };